const utils = require('frontend-controller/lib/utils')
const getToggle = (fieldCode, langDependentNames = { 'de-at': 'Feldname'}) => ({
    fieldCode,
    config: {
        strict: true,
        slimSwitch: true
    },
    atom: {
        code: 'BOOLEAN_TOGGLE',
        dataType: 'boolean',
        renderType: 'toggle',
    },
    lang: utils.isCollection(langDependentNames) ? utils.mapValues(langDependentNames, value => utils.isCollection(value) ? value : { label: value }) : { 'de-at': { label: langDependentNames }},
})

module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form',
    ],

    formMapping: {
        cols: [[{
            type: 'fieldGroup',
            source: 'resourceFields'
        }]]
    },

    config: {
        resourceConnected: false,
    },


    model: {
        fields: [
            getToggle('showProjectTermJobs', 'Meine Termine anzeigen'),
            getToggle('showAllProjectTerms', 'Alle Termine anzeigen'),
            getToggle('showAbsence', 'Meine Abwesenheiten anzeigen'),
            // getToggle('showAdvertisements', 'Ausschreibungen anzeigen'),
        ]
    },

    methods: {
        prepare(storage){
            // const employee = (((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}

            let showAllProjectTermsGranted = false
            if(storage.user){
                showAllProjectTermsGranted = storage.user.hasRoleInScope('office')
            }

            const fieldConfig = {
                fields: {
                    showProjectTermJobs: {
                        default: 1,
                    },
                    showAllProjectTerms: {
                        disabled: !showAllProjectTermsGranted,
                    },
                    showAbsence: {
                        default: 1,
                    },
                    // showAdvertisements: {
                    //     disabled: employee.status !== 'external',
                    // },
                }
            }

            // merge fieldConfigs
            for(const fieldCode in fieldConfig.fields || {}){
                utils.forEach(this.model.fields || [], (field, modelFieldIndex) => {
                    if(field.fieldCode === fieldCode){
                        utils.refMerge(field.config, fieldConfig.fields[fieldCode])
                        return false
                    }
                })
            }
        },

        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			{} - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            // NOTE: this function can be overwritten by inherited form components if needed
            const schedulerOptions = (this.model.dirtyFields.data || {}).attributes || {}
            this.triggerClosest('schedulerOptionsChanged', { schedulerOptions }, 'base_scheduler_scheduler')
        },
    },
}